import { ArrowForwardIcon, SurfaceAreaIcon } from '@traceair/webapp-icons';
import { Gold90, Gray100, Gray70, typeCompact14MediumProperties } from '@traceair/tds';
import { classes, stylesheet } from 'typestyle';
import { ScheduledFlight, Site } from '../../../../../types';
import PanoIcon from '../../../../../images/components/PanoIcon';
import { UploadData } from '../../../../../store/uploadStore';
import { formatDate } from '../../../../../libs/dates';
import { makeSafeIsoDateString } from '../../../../../libs/doneDate';

const css = stylesheet({
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    ...typeCompact14MediumProperties,
  },
  date: {
    display: 'flex',
    gap: 2,
    color: Gray100,
  },
  dateChanged: {
    $nest: {
      '&&': {
        color: Gold90,
      },
    },
  },
});

interface Props {
  site?: Site;
  isPano: boolean;
  upload: UploadData | undefined;
  schedule?: ScheduledFlight;
}

export const FlightUploadHeader = ({ site, isPano, upload, schedule }: Props) => {
  const dateStr = upload?.overview.date ?? schedule?.flightDateIso;
  const dateFormatted = dateStr ? formatDate({ date: makeSafeIsoDateString(dateStr), withTime: false }) : undefined;
  const isDateChanged =
    upload?.overview &&
    schedule?.flightDateIso &&
    makeSafeIsoDateString(upload.overview.date) !== schedule.flightDateIso;

  const icon = isPano ? <PanoIcon color={Gray70} /> : <SurfaceAreaIcon color={Gray70} />;

  let title = 'Scan';
  if (isPano) {
    if (site?.projectInfo.parsedPanoramaLocations?.length) {
      const panoramasPerScan = site?.projectInfo.parsedPanoramaLocations.length;
      title = panoramasPerScan === 1 ? '1 panorama' : `${panoramasPerScan} panos`;
    } else {
      title = 'Panos';
    }
  }

  return (
    <header>
      <div className={css.title}>
        {icon}
        {title}

        {!!dateFormatted && !!isDateChanged && (
          <div className={classes(css.date, isDateChanged && css.dateChanged)}>
            <>
              <ArrowForwardIcon size={16} color={Gold90} />
              date changed to&nbsp;
            </>
            {dateFormatted}
          </div>
        )}
      </div>
    </header>
  );
};
